import React, { useState , useEffect} from 'react';
import styles from './dwn-style.module.css';
import { useNavigate } from 'react-router-dom';
import {useLocation } from "react-router-dom";


const FitOnboard = () => {

  const location = useLocation();
  const navigate = useNavigate();


  const [eligibilityResults] = useState(location.state.eligibilityResults)
  const [preScreening] = useState(location.state.preScreening)
  const [pid] = useState(location?.state?.pid )
  const[access, setAccess] = useState(-1)


  const [onBoardData, setOnBoardData] = useState({
    parentFirstName:  preScreening.firstName,
    parentLastName: preScreening.lastName,
    parentAddress: '',
    parentCity: '',
    parentZIP: eligibilityResults.ZIP,
    parentState: '',
    parentCountry: 'United States',
    parentPhone: preScreening.phoneNumber,
    parentUsername: '',
    parentPassword: '',
    childFirstName: '',
    childLastName: '',
    childUsername: '',
    childPassword: '',
  });


  useEffect(() => {
    if (pid == null) {
      navigate('/');
    } else {
      const body = { "username": pid, "scope": "participant" };
      let connectionString = "https://app.digitalwellnessnurse.com"; //https://app.digitalwellnessnurse.com  http://localhost:2001
  
      fetch(`${connectionString}/api/portal/verify`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: "include",
        body: JSON.stringify(body),
      })
        .then((response) => {
          setAccess(response.status);
          return response.json();
        })
        .then((json) => {
          if (json.access !== 200) {
            navigate('/');

          } 
        })
        .catch((error) => {
          console.error("Error verifying access:", error);
        });
    }
     }, [pid, navigate]); 



  const handleChange = (e) => {
    const { name, value } = e.target;
    setOnBoardData({
      ...onBoardData,
      [name]: value,
    });
  };

  const generateUsernames = async () => {
    const maxLastNameLength = 5;
  
    // POST request to get the number of families onboarded
    const response = await fetch("https://app.digitalwellnessnurse.com/api/portal/fit/get-family-count", {   //https://app.digitalwellnessnurse.com  http://localhost:2001
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({})
    });
  
    const { familyCount } = await response.json();
  
    // Increment counter to represent the current family
    const familyIndex = familyCount + 1;
  
    // Generate base usernames
    const parentBase =
      onBoardData.parentFirstName.charAt(0).toLowerCase() +
      onBoardData.parentLastName.substring(0, Math.min(maxLastNameLength, onBoardData.parentLastName.length)).toLowerCase();
  
    const childBase =
      onBoardData.childFirstName.charAt(0).toLowerCase() +
      onBoardData.parentLastName.substring(0, Math.min(maxLastNameLength, onBoardData.parentLastName.length)).toLowerCase();
  
    // Append family index and role suffix
    const parentUsername = `${parentBase}${familyIndex}d1`;
    const childUsername = `${childBase}${familyIndex}d2`;
  
    return { parentUsername, childUsername };
  };

  const validateOnBoardData = (data) => {
   

    const emptyFields = {};
  
    for (const [key, value] of Object.entries(data)) {
      if (!value.trim()) {
        emptyFields[key] = `${key} is required.`;
      }
    }
  
    return emptyFields;
  };
  
  
  const handleNext = async () => {
    if (onBoardData.parentPassword.length < 9) {
      alert('Password must be at least 9 characters long.');
      return;
    } else {
      // Generate usernames
      const { parentUsername, childUsername } = await generateUsernames();
  
      // Update onBoardData
      const updatedOnBoardData = {
        ...onBoardData,
        parentUsername,
        childUsername,
      };
  
      setOnBoardData(updatedOnBoardData);
      // Navigate with the updated data

      const emptyFields = validateOnBoardData(updatedOnBoardData);
      if (Object.keys(emptyFields).length === 0) {
            // All fields are filled, navigate to the next page
            navigate('/FitWelcome', { state: { pid:pid, onBoardData: updatedOnBoardData, eligibilityResults: eligibilityResults } });
          } else {
            // Show an alert with the missing fields
            const missingFieldsMessage = Object.values(emptyFields).join('\n');
            alert(`Please fill in the following fields:\n${missingFieldsMessage}`);
          }
    }
  };
  


  return (
    <div className={styles.signupForm}>
      <h2 className={styles.header}>Parent Information</h2>
      <div className={styles.formGroup}>
        <label>First Name:
          <input type="text" name="parentFirstName" value={onBoardData.parentFirstName} onChange={handleChange} required />
        </label>
      </div>
      <div className={styles.formGroup}>
        <label>Last Name:
          <input type="text" name="parentLastName" value={onBoardData.parentLastName} onChange={handleChange} required />
        </label>
      </div>
      <div className={styles.formGroup}>
        <label>Address:
          <input type="text" name="parentAddress" value={onBoardData.parentAddress} onChange={handleChange} required />
        </label>
      </div>
      <div className={styles.formGroup}>
        <label>City:
          <input type="text" name="parentCity" value={onBoardData.parentCity} onChange={handleChange} required />
        </label>
      </div>
      <div className={styles.formGroup}>
        <label>State:
          <input type="text" name="parentState" value={onBoardData.parentState} onChange={handleChange} required />
        </label>
      </div>
      <div className={styles.formGroup}>
        <label>State:
          <input type="text" name="ZIP" value={onBoardData.parentZIP} onChange={handleChange} required />
        </label>
      </div>
      <div className={styles.formGroup}>
        <label>Country:
          <input type="text" name="parentCountry" value={onBoardData.parentCountry} onChange={handleChange} disabled />
        </label>
      </div>
      <div className={styles.formGroup}>
        <label>Phone Number:
          <input type="tel" name="parentPhone" value={onBoardData.parentPhone} onChange={handleChange} required />
        </label>
      </div>
      <div className={styles.formGroup}>
        <label>Password:
          <input type="text" name="parentPassword" value={onBoardData.parentPassword} onChange={handleChange} required />
        </label>
      </div>
      <h2 className={styles.header}>Teen Information</h2>
      <div className={styles.formGroup}>
        <label>First Name:
          <input type="text" name="childFirstName" value={onBoardData.childFirstName} onChange={handleChange} required />
        </label>
      </div>
      <div className={styles.formGroup}>
        <label>Last Name:
          <input type="text" name="childLastName" value={onBoardData.childLastName} onChange={handleChange} required />
        </label>
      </div>
      <div className={styles.formGroup}>
        <label>Password:
          <input type="text" name="childPassword" value={onBoardData.childPassword} onChange={handleChange} required />
        </label>
      </div>
      <button className={styles.submitBtn} type="button" onClick={handleNext}>Next</button>
    </div>
  );
};

export default FitOnboard;
